/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import JsController from '../../js-controller';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, unicorn/prevent-abbreviations
declare let jQuery: any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let window: any;
export default (app: App) => {

    const controller = new JsController(app, 'gift-tile');
    
    controller.addMountFunction(async() => {
        //set jquery alias if jquery is already loaded on the page by epiforms
        if(typeof jQuery !== 'undefined' && jQuery && !window.$){
            window.$=jQuery;
        }

        await  mountComponent();
    })

    return controller.init();
}

export async function mountComponent() {
    // let host = location.hostname;
    const bindingElement= document.querySelector<HTMLElement>('.rtc-buy-card');
    if(bindingElement){
        const authUrl = bindingElement.dataset.authUrl;
        const data = {
            apiKey: bindingElement.dataset.apiKey ??"",
            app: bindingElement.dataset.app??"",
            name: bindingElement.dataset.name??"",
            email: bindingElement.dataset.email??"",
            mobile: bindingElement.dataset.mobile??""
        };
        if(authUrl){
            try {
                // e.preventDefault();
                const response = await fetch(authUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    },
                    body: new URLSearchParams(data),
                });
 
                const responseData = await response.json();
                const status = responseData.status;

                if (status === "success") {
                    const authToken = responseData.authToken;
                    if (document.cookie.includes("tr-app-auth-token")) {
                        document.cookie =
                        "tr-app-auth-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    }

                    document.cookie = `tr-app-auth-token=${authToken}; expires=${new Date(
                        Date.now() + 604_800_000
                    ).toUTCString()}; path=/;`;

                } else {
                    console.log("Failed");
                }
            } catch (error) {
                console.error(error);
            }
        }
    }
}
